import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelTestimonialEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelTestimonialEntity
